const isDomainRebrand = window.location.hostname === process.env.APP_DOMAIN_REBRAND;

export default {
  urls: {
    API_ENDPOINT: isDomainRebrand
      ? process.env.API_ENDPOINT_REBRAND : process.env.API_ENDPOINT,
    KLICKART_URL: isDomainRebrand
      ? process.env.KLICKART_URL_REBRAND : process.env.KLICKART_URL,
    KLICKART_AUTH_URI: isDomainRebrand
      ? process.env.KLICKART_AUTH_URI_REBRAND : process.env.KLICKART_AUTH_URI,
    KLICKBOX_MANAGER_SCRIPT: isDomainRebrand
      ? process.env.KLICKBOX_MANAGER_SCRIPT_REBRAND : process.env.KLICKBOX_MANAGER_SCRIPT,
    THEME_CDN_URI: isDomainRebrand
      ? process.env.THEME_CDN_URI_REBRAND : process.env.THEME_CDN_URI,
  },
};



/** WEBPACK FOOTER **
 ** ./src/config/rebrand/index.js
 **/